export default __webpack_public_path__ + "static/media/clases-de-baile.8913fea3.jpg";